import "./css/styles.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaShip, FaUsers } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import React, {Component} from "react";
import ReactPlayer from 'react-player';
import Countdown from 'react-countdown-now';
import { Link } from 'react-router-dom';
import moment from 'moment';
import TelevisionBreakpoint from "../../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../../components/responsive_utilities/phone_breakpoint";
import { SponsorsScroller} from "../../../components/SponsorsScroller";
import { SponsorsScrollerTv} from "../../../components/SponsorsScrollerTv";
import { SancoHeader } from "../../../components/SancoHeader";
import { AnglerScores} from "./comps/AnglerScores";
import { TournamentNumsPhone} from "./comps/TournamentNumsPhone";
import { TournamentNumsTv} from "./comps/TournamentNumsTv";
import { TournamentNums} from "./comps/TournamentNums";
import { TournamentDetails} from "./comps/TournamentDetails";
import { TournamentDetailsTv} from "./comps/TournamentDetailsTv";
import { TournamentDetailsPhone} from "./comps/TournamentDetailsPhone";
import { Scroller } from "./comps/Scroller";
import { ScrollerTv } from "./comps/ScrollerTv";
import { ScrollerMobileVert } from "./comps/ScrollerMobileVert";
import { SpeciesScoresColTv } from "./comps/SpeciesScoresColTv";
import { SpeciesScoresColPhone } from "./comps/SpeciesScoresColPhone";
import { SpeciesScoresCol } from "./comps/SpeciesScoresCol";
import { SpeciesScoresColVert } from "./comps/SpeciesScoresColVert";
import { Hookups } from "./comps/Hookups";
import { HookupsTv } from "./comps/HookupsTv";
import { HookupsPhone } from "./comps/HookupsPhone";
import { Logs } from "./comps/Logs";
import { LogsTv } from "./comps/LogsTv";
import { LogsPhone } from "./comps/LogsPhone";

import { TideChart } from "../../../components/TideChart";
import { TideChartPhone } from "../../../components/CompsPhone/TideChartPhone";
var Sound = require('react-sound').default; 

const sancoLogo = require('../../../media/sanco-logo-black.png');

const dragSound = require('../../../media/drag.wav');

const sponsorLogos = ['https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2F1200x1200%20fvlogo_pescadora.jpg?alt=media&token=a105dda1-1ed8-498f-9744-7467957cc745', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2F506outdoors.png?alt=media&token=2f057bfa-c14e-47bd-bf92-0f99bd7bb1b1', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FAccurate%20.jpg?alt=media&token=2bfbc556-4c86-4042-9542-0810cee1817f', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FArtboard%201.png?alt=media&token=5c1e2486-23a5-4188-8365-2941efdb274e', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FElite.jpg?alt=media&token=c2ea0167-96f4-45ce-9e55-d0d0776a8b4d', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FGray%20Fishtag%20logo.jpg?alt=media&token=e92e5e4a-c45e-4720-86d1-3e6b9f2e2eb1', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FHBG%20logo_final_vert.jpg?alt=media&token=9e4847ab-d703-48a1-8eb6-abd89b6faef9', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FIGFTO_logo.png?alt=media&token=ff3339b4-5669-4899-8850-230cfcd699d7', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FLogo.GIF?alt=media&token=5b1481dd-97fd-4c34-ac28-27326ea542d3', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FLogo.jpg?alt=media&token=63d0c6e5-4ac6-4ddc-b713-274ce69a1077', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FPM.logo.final.png?alt=media&token=b03be194-1fd0-48b2-bdf4-8c0f8cebb83f', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FPescdora%20_logo.png?alt=media&token=ba74a745-6921-4205-bcc9-1059be78e657', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2FSquidnation.jpg?alt=media&token=1f0811fe-c108-4888-9b6f-96f8c1ded2fa', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Fcostalogo.png?alt=media&token=3d222f9c-a969-4199-94f1-1aaefcb67dea', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Ffecop.png?alt=media&token=48ce4630-77b5-4719-9b6b-493391875af9', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Fhighseas.png?alt=media&token=7019c26e-edb3-4a8b-a9c6-95eeb8f807b4', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Fhoustonbiggame.png?alt=media&token=300569e5-1262-4134-86d7-29592a0b44aa', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Fmaricruz.png?alt=media&token=4ae74442-9650-4381-bc82-d1e595d39687', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Fmpvyard.png?alt=media&token=b7967753-f5a8-42d5-8ef7-b7546208ecf6', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Ftackleshop.png?alt=media&token=6f8f2d30-727f-4f9f-92c3-692d80f94979'];

var firebase = require('firebase/app');
require('firebase/database');

class Pescadora extends Component {
  
  constructor() {
    super();
    this.state = {
      tournament: [],
      tourDay1: '',
      tourDay2: '',
      tourDay3: '',
      tourDay4: '',
      countDownDate: '',
      buttonStatus: 'current',
      buttonStatus1: 'notCurrent',
      buttonStatus2: 'notCurrent',
      buttonStatus3: 'notCurrent',
      buttonStatus4: 'notCurrent',
      tournamentLogo: '',
      tournamentName: '',
      boats: [],
			teamNums: '',
      anglersRaw: {},
			anglerNums: '',
      species: [],
      speciesRaw: {},
      boatsRaw: {},
      currentLogs: {},
      currentBoatScores: [],
      logs: [],
      fishLogs: [],
      fishLogsOne: [],
      fishLogsTwo: [],
      fishLogsThree: [],
      fishLogsFour: [],
      hookups: [],
      hps: [],
      boatLogs: [],
      boatTotals: [],
      boatTotalsOne: [],
      boatTotalsTwo: [],
      boatTotalsThree: [],
      boatTotalsFour: [],
      boatScores: [],
      boatScoresOne: [],
      boatScoresTwo: [],
      boatScoresThree: [],
      boatScoresFour: [],
      boatScoresArray: [],
      showAll: true,
      showDay1: false,
      showDay2: false,
      showDay3: false,
      showDay4: false,
      newLog: false,
      newItem: false,
      playing: 'STOPPED',
      vidPlaying: true,
      loading: true,
      newFishLog: [],
      vidLogs: [],
      vidList: [],
      currentVideo: '',
      boardId: '',
      boardName: '',
      videoVis: 'visible',
      displayVis: 'inline',
      loadingVis: 'none',
      loadingVis2: 'inline',
      speciesPoints: [],
      boatFishLogs: [],
      tourDay: '',
      currentTourDay: '',
			currentDayState: 'All'
    };
    this.baseRef = firebase.database().ref('/');
    this.ref = firebase.database().ref('tournaments');
    this.tourRef = firebase.database().ref('tournaments/-LQoim5R3GFJ0t76EEBd');
    this.handleButtonPress = this.handleButtonPress.bind(this)
    this.handleButtonRelease = this.handleButtonRelease.bind(this)
  }
  
  componentWillMount() {
    this.tourRef.on('value', this.handleTournamentUpdate); 
    this.tourRef.child('fishLogs').on('child_added', this.handleFishLogAdded);
    this.tourRef.child('fishLogs').on('child_changed', this.handleFishLogChanged);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
		this.baseRef.child('refreshPlaylist').on('child_changed', this.reloadPlaylist);
  }
  
  componentDidMount() {
    window.addEventListener("keyup", this.keyHandling);
		this.fetchVideosList();
  }
    
  componentWillReceiveProps(newProps) {
    this.setState({tourDay: this.props.match.params.tourDay});
    this.getBoats();
  }
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    }
  }
  
  reloadPage = () => {
    window.location.reload(true);
  }
	
	reloadPlaylist = () => {
    this.fetchVideosList();
  }
  
  handleTournamentUpdate = (snapshot) => { 
    if(snapshot.val().fishLogs) {
      var fishLogsArray = Object.entries(snapshot.val().fishLogs);
    }
    var fishLogsList = [];
    var hookupsList = [];
    var speciesArray = Object.entries(snapshot.val().species);
    var speciesList = [];
    var boatsArray = Object.entries(snapshot.val().boats);
    var boatsList = [];
    if(snapshot.val().videos) {
        var tourVideos = Object.entries(snapshot.val().videos);
    }
      
    if(fishLogsArray) {
      fishLogsArray.forEach((log) => {
        fishLogsList.push({
          id: log[0],
          boatId: log[1].boatId,
          boatName: log[1].boatName,
					teamName: log[1].name,
          boatThm: log[1].photoUrl,
          speciesId: log[1].speciesId,
          speciesName: log[1].speciesName,
          anglerId: log[1].anglerId,
          anglerName: log[1].anglerName,
          lbs: log[1].fishLbs,
          hookedupDate: log[1].hookedupDate,
          catchDate: log[1].catchDate,
          clipUrl: log[1].clipUrl,
          status: log[1].status
        });
        if (log[1].status === 'hooked up'){
          hookupsList.push ({
            id: log[0],
            boatId: log[1].boatId,
            boatName: log[1].boatName,
						teamName: log[1].name,
            boatThm: log[1].photoUrl,
            speciesId: log[1].speciesId,
            speciesName: log[1].speciesName,
            anglerId: log[1].anglerId,
            anglerName: log[1].anglerName,
            lbs: log[1].fishLbs,
            hookedupDate: log[1].hookedupDate,
            status: log[1].status
          })
        }
      })
    }
    
    var countDownDate = moment(new Date(snapshot.val().day1Date)).format('LLL');
    var tournament = {
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
			tournamentTimeZone: snapshot.val().timeZone,
      venue: snapshot.val().venue,
      captMeetingTime: snapshot.val().captMeetingTime,
      captMeetingLoc: snapshot.val().captMeetingLoc,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
    }
    
    this.setState({
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
			tournamentTimeZone: snapshot.val().timeZone,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      species: speciesList, 
      speciesRaw: snapshot.val().species,
      anglersRaw: snapshot.val().anglers,
			anglerNums: Object.keys(snapshot.val().anglers).length,
      boatsRaw: snapshot.val().boats,
			teamNums: Object.keys(snapshot.val().boats).length,
      boats: boatsList,
      hps: hookupsList,
      newItem: true,
      fishLogs: this.sortFishLogs(fishLogsList),
      countDownDate,
      tournament
    });
      
    speciesArray.forEach((specie) => {
      speciesList.push({
        id: specie[0],
        name: specie[1].name,
        points: specie[1].points,
        scoreType: specie[1].scoreType,
        speciesImageUri: specie[1].speciesImageUri
      })
    })
    
    boatsArray.forEach((boat) => {
      boatsList.push({
        id: boat[0],
        name: boat[1].name,
				teamName: boat[1].name,
				boatName: boat[1].boatName,
        class: boat[1].boatClass,
        photoURL: boat[1].photoUrl,
      })
    })
		
		
    this.getBoats();
  }
  
  isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }

  filterDailyLogs(day, logs){
      var theDay = day.substring(0,10);
      var fishLogs =  logs.filter(function(log) {
        return log.catchDate.substring(0,10) == theDay;
      });
      var sortedLogs = this.sortFishLogs(fishLogs)
      return sortedLogs
  }
  
  
  sortFishLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    return logs
  }
  
  handleFishLogAdded = (snapshot) => {
    if (!this.state.newItem) return;
    var fishLogs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDate) {
      var hd = this.formatDate(snapshot.val().hookedupDate);
    } else {
      var hd = null;
    }
      fishLogs.unshift({
        id: snapshot.key,
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
				teamName: snapshot.val().name,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        lbs: snapshot.val().fishLbs,
        anglerId: snapshot.val().anglerId,
        anglerName: snapshot.val().anglerName,
        photoUrl: snapshot.val().photoUrl,
        status: snapshot.val().status,
        hookedupDate: hd,
        catchDate: cd,
        });
      this.setState({
        vidLogs,
        newLog: true,
        vidPlaying: false,
        displayVis: 'none',
        newFishLog: {
          boatId: snapshot.val().boatId,
          boatName: snapshot.val().boatName,
					teamName: snapshot.val().name,
          photoUrl: snapshot.val().photoUrl,
          anglerName: snapshot.val().anglerName,
          anglerId: snapshot.val().anglerId,
          speciesId: snapshot.val().speciesId,
          speciesName: snapshot.val().speciesName,
          fishLbs: snapshot.val().fishLbs,
          status: snapshot.val().status,
          hookedupDate: hd,
          catchDate: cd,
        }
      })
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({displayVis: 'inline'}); }.bind(this), 10000);
    setTimeout(function() { this.setState({vidPlaying: true}); }.bind(this), 10500);
  }
  
  sortLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    this.getBoats();
  }
  
  handleFishLogChanged = (snapshot, last) => {
    var logs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDateDate) {
      var hd = this.formatDate(snapshot.val().hookedupDateDate);
    } else {
      var hd = null;
    }
    vidLogs.push({
      id: snapshot.key,
      boatId: snapshot.val().boatId,
      boatName: snapshot.val().boatName,
      speciesId: snapshot.val().speciesId,
      speciesName: snapshot.val().speciesName,
      lbs: snapshot.val().fishLbs,
      anglerId: snapshot.val().anglerId,
      anglerName: snapshot.val().anglerName,
      catchDate: this.formatDate(snapshot.val().catchDate),
      clipUrl: snapshot.val().clipUrl,
      status: snapshot.val().status
    })
    logs.map(log => {
      if(log.id === snapshot.key) {
        log.lbs = snapshot.val().fishLbs;
        log.boatId = snapshot.val().boatId;
        log.boatName = snapshot.val().boatName;
        log.speciesId = snapshot.val().speciesId;
        log.speciesName = snapshot.val().speciesName;
        log.anglerId = snapshot.val().anglerId;
        log.anglerName = snapshot.val().anglerName;
        log.catchDate = this.formatDate(snapshot.val().catchDate);
        log.clipUrl = snapshot.val().clipUrl;
        log.status = snapshot.val().status;
      }
    });
    this.setState({
      vidLogs,
      fishLogs:logs,
      newLog: true,
      vidPlaying: false,
      videoVis: 'hidden',
      displayVis: 'none',
      newFishLog: {
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
				teamName: snapshot.val().name,
        photoUrl: snapshot.val().photoUrl,
        anglerName: snapshot.val().anglerName,
        anglerId: snapshot.val().anglerId,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        fishLbs: snapshot.val().fishLbs,
        status: snapshot.val().status,
        hookedupDateDate: hd,
        catchDate: cd,
        }
    })
    this.getBoats();
    setTimeout(function() { this.setState({newLog: false}) }.bind(this), 10000);
    setTimeout(function() { this.setState({displayVis: 'inline'}) }.bind(this), 10000);
    setTimeout(function() { this.setState({vidPlaying: true}); }.bind(this), 10500);
  }
	
	fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU'
		const channelID = 'PLBE2HTUQ9kZvPk-l5-parBnu5a4e6iZA7'
		const results = 20;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					vidList.push({
						url: 'https://youtu.be/' + item.snippet.resourceId.videoId,
						title: item.snippet.title,
						desc: item.snippet.description
					})
				})
				this.setState({
					vidList,
					currentVideo: vidList[0],
				})
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  getBoats() {
    var logs = this.state.fishLogs;
    var boats = this.state.boats;
    var boatLogs = [];
    var boatLogsOne = [];
    var boatLogsTwo = [];
    var boatLogsThree = [];
    var boatLogsFour = [];
    boats.forEach((boat) => {
      var boatFish = [];
      var boatFishOne = [];
      var boatFishTwo = [];
      var boatFishThree = [];
      var boatFishFour = [];
      
      //Get FishLog for each Boat
      logs.forEach((fishLog) => {
        if(!fishLog.catchDate){
          return
        }
        if(boat.id === fishLog.boatId){
          if(fishLog.length !== 0) {
            boatFish.push(fishLog);
          }
        }
        if(this.state.tourDay1.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishOne.push(fishLog);
            }
          }
        } else if(this.state.tourDay2.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishTwo.push(fishLog);
            }
          }
          
        } else if(this.state.tourDay3.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishThree.push(fishLog);
            }
          }
        } else if(this.state.tourDay4.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishFour.push(fishLog);
            }
          }
        }
      });
      if(boatFish.length !== 0) {
        boatFish.sort(function(a, b) {
            var dateA = new Date(a.catchDate), dateB = new Date(b.catchDate);
            return dateA - dateB;
        });
        var lastFishInt = (boatFish.length - 1);
        var lastFishTime = boatFish[lastFishInt].catchDate;
				var teamName = boatFish[0].teamName;
        boatLogs.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFish,
          lastFishTime:  lastFishTime
        });
      }
      if(boatFishOne.length !== 0) {
        var lastFishIntOne = (boatFishOne.length - 1);
        var lastFishTimeOne = boatFishOne[lastFishIntOne].catchDate;
				var teamName = boatFishOne[0].teamName;
        boatLogsOne.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishOne,
          lastFishTime:  lastFishTimeOne
        });
      } 
      
      if(boatFishTwo.length !== 0) {
        var lastFishIntTwo = (boatFishTwo.length - 1);
        var lastFishTimeTwo = boatFishTwo[lastFishIntTwo].catchDate;
				var teamName = boatFishTwo[0].teamName;
        boatLogsTwo.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishTwo,
          lastFishTime:  lastFishTimeTwo
        });
      }
      if(boatFishThree.length !== 0) {
        var lastFishIntThree = (boatFishThree.length - 1);
        var lastFishTimeThree = boatFishThree[lastFishIntThree].catchDate;
				var teamName = boatFishThree[0].teamName;
        boatLogsThree.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishThree,
          lastFishTime:  lastFishTimeThree
        });
      }
      
      if(boatFishFour.length !== 0) {
        var lastFishIntFour = (boatFishFour.length - 1);
        if(lastFishIntFour) {
          var lastFishTimeFour = boatFishFour[lastFishIntFour].catchDate;
					var teamName = boatFishFour[0].teamName;
          boatLogsFour.push({
            boatId: boat.id,
            boatName: boat.boatName,
						teamName,
            boatClass: boat.class,
            boatThm: boat.photoURL,
            boatCaughtFish: boatFishFour,
            lastFishTime: lastFishTimeFour
          });
        }
      }
    });
    var bTotals = this.getBoatTotals(boatLogs);
    var bTotalsOne = this.getBoatTotals(boatLogsOne);
    var bTotalsTwo = this.getBoatTotals(boatLogsTwo);
    var bTotalsThree = this.getBoatTotals(boatLogsThree);
    var bTotalsFour = this.getBoatTotals(boatLogsFour);
    this.setState({
      logs: boatLogs,
      currentLogs: boatLogs,
      fishLogsOne: boatLogsOne,
      fishLogsTwo: boatLogsTwo,
      fishLogsThree: boatLogsThree,
      fishLogsFour: boatLogsFour,
      currentBoatScores: this.scoreSortFilter(bTotals),
      boatScores: this.scoreSortFilter(bTotals),
      boatScoresOne: this.scoreSortFilter(bTotalsOne),
      boatScoresTwo: this.scoreSortFilter(bTotalsTwo),
      boatScoresThree: this.scoreSortFilter(bTotalsThree),
      boatScoresFour: this.scoreSortFilter(bTotalsFour),
    })
    setTimeout(this.toggleLoading, 3000)
  }

  toggleLoading = () => {
    this.setState({
        loading: false,
        loadingVis: 'inline',
        loadingVis2: 'none',
      });
  }

  getBoatTotals(bLogs) {
    var boatTotals = [];
    bLogs.forEach((boatLog) => {
      var logs = boatLog.boatCaughtFish;
      var sps = this.state.species;
      var boatCounts = [];
      var boatPoints = [];
      var boatLbsPoints = [];
      var boatTotal = '';
      
      sps.forEach((specie) => {
        var speciesId = specie.id
        var speciesName = specie.name;
        var speciesPoints = specie.points;
        var scoreType = specie.scoreType;
        var speciesCount = [];
        var speciesTimes = [];
        var speciesScores = 0;
         
        if (scoreType === 'QTY'){
          logs.forEach((log) => {
           
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesTimes.push(log.catchDate);
            }
          }); 
            
          var count = speciesCount.length;
          var points = parseFloat(count * speciesPoints);
          var totalPoints = (points + speciesScores)
          boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
						teamName: boatLog.teamName,
            boatThm: boatLog.boatThm,
            boatClass: boatLog.boatClass,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints: totalPoints,
            speciesTimes: speciesTimes
          });
          boatPoints.push(totalPoints);
        }
        if (scoreType === 'LBS'){
          logs.forEach((log) => {
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesPoints = speciesPoints * log.lbs;
            }
          });
          if(speciesCount.length > 0) {
            boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
						teamName: boatLog.teamName,
            boatThm: boatLog.boatThm,
            boatClass: boatLog.boatClass,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints,
          });
          }
          boatLbsPoints.push(totalPoints);
        }
      });
      boatTotal = boatPoints.reduce(function(sum, value) {
        return sum + value;
      }, 0);
      boatTotals.push({
        id: boatLog.boatId,
        boatName: boatLog.boatName,
				teamName: boatLog.teamName,
        boatClass: boatLog.boatClass,
        boatThm: boatLog.boatThm,
        speciesCounts: boatCounts,
        total: boatTotal,
        lastFishTime: this.formatDate(boatLog.lastFishTime)
      })
    })
    return boatTotals
  }

  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    
    boatScores.sortOn("total", "lastFishTime");
    boatScores.reverse();
    
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
    return bScores;  
  }

  formatDate(date) {
    var options = {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Costa_Rica',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);
    return formattedDate;
  }

  catchDate(date) {
    var catchDate = new Date(date)
    var hour = catchDate.getHours();
    var secs = catchDate.getSeconds();
    var ampm = hour >= 12 ? 'PM' : 'AM';
    var minutes = catchDate.getMinutes();
    hour = hour % 12;
    hour = hour ? hour : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var dateString = hour + ':' + minutes + ':' + secs + '' + ampm;
    
    return dateString
  }

  nextVideo(currentVideo) {
    const videos = this.state.vidList;
    var i = videos.length - 1;
    var index = videos.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videos[next]
    })
  }

  buffering(currentVid) {
      console.log('BUFFERING')
      setInterval(this.nextVideo(currentVid), 10000)
  }

  handleButtonPress (event) {
      var day = event.target.id;
      if(day === "All"){
          var currentLogs = this.state.fishLogs;
          var currentBoatScores = this.state.boatScores;
      } else if (day === "Day1") {
          var currentLogs = this.state.fishLogsOne;
          var currentBoatScores = this.state.boatScoresOne;
      } else if (day === "Day2") {
          var currentLogs = this.state.fishLogsTwo;
          var currentBoatScores = this.state.boatScoresTwo;
      }
    this.setState({
        currentLogs,
        currentBoatScores
    })
    event.preventDefault();
  }

  handleButtonRelease (event) {
    var day = event.target.id;
      if(day === "All"){
          var currentLogs = this.state.logs;
          var currentBoatScores = this.state.boatScores;
      } else if (day === "Day1") {
          var currentLogs = this.state.fishLogsOne;
          var currentBoatScores = this.state.boatScoresOne;
      } else if (day === "Day2") {
          var currentLogs = this.state.fishLogsTwo;
          var currentBoatScores = this.state.boatScoresTwo;
      }
    this.setState({
        currentLogs,
        currentBoatScores,
				currentDayState: day
    })
    event.preventDefault();
  }
  render () {
    if(this.state.newFishLog.photoUrl) {
        var imageUrl = this.state.newFishLog.photoUrl;
      } else {
        var imageUrl = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';
      }
    if(this.state.newLog) {
      var popBox = 
          <div className="popContainer">
              <div
                id="boatContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  flex: 1,
                  minHeight: '400px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBox">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBox">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainer">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerName">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBox">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div> 
                  </div> 
                  { this.state.newFishLog.fishLbs > 0 ? <div className="fishLbs">
                      {this.state.newFishLog.fishLbs} LBS.
                    </div> : null }
               </div>
            </div>
    } else {
      var popBox = null;
    }

    if(this.state.newLog) {
      var popMobileBox = 
          <div className="popContainer">
              <div
                id="boatMobileContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '250px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBoxMobile">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBoxMobile">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainerMobile">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerNameMobile">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBoxMobile">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div>
                  </div> 
                    { this.state.newFishLog.fishLbs ? <div className="fishLbsPhone">
                      {this.state.newFishLog.fishLbs}
                    </div> : null }
               </div>
            </div>
    } else {
      var popMobileBox = null;
    }
    
    if(this.state.newLog) {
      var popBoxTv = 
          <div className="popContainer">
              <div
                id="boatTVContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '630px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="pelDetailsBoxTv">
                    <div className="pelCaughtBoxTv">
                        {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </div>
                    <div className="pelDetailsRow">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '200px',
                        height: '100px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>

                    <div className="anglerDetailRowTv">
                        <div className="anglerNameTv">
                          {this.state.newFishLog.anglerName}
                        </div>
                        <div className="dateBoxTv">
                          {this.catchDate(this.state.newFishLog.catchDate)}
                        </div>
                    </div>

                  </div> 
                    <div className="boatNameContainerTv">
                      {this.state.newFishLog.boatName}
                    </div>
                    { this.state.newFishLog.fishLbs > 0 ? <div className="fishLbsTv">
                      {this.state.newFishLog.fishLbs} LBS
                    </div> : null }
                    </div>
               </div>
            </div>
    } else {
      var popBoxTv = null;
    }
    return (
      <div className="main-container">
          <TelevisionBreakpoint>
          <div style={{zIndex: -1, display: this.state.loadingVis, padding: '5%'}}>
          <div className="headerBox">
            <div style={{flex: 1, display: 'flex', justifyContent: 'flex-start'}}>
              <div className='pesc_tourLogoTv' 
                style={{
                  backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                }} />
            </div>
            <div style={{flex: 1, justifyContent: 'center'}}>
                <center><img src={'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/pescadoralogos%2Fcostalogolong.png?alt=media&token=5f439e6a-8538-4453-8e7c-14e4bf9091a4'} width='50%' alt='Tournamant Logo'/></center>
                <div className="logColumnTitle"> PESCADORA 2020 UNOFFICIAL LEADERBOARDS</div>
            </div>
            <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <div className='pesc_tourLogoTv' 
                style={{
                  backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                }} />
            </div>
          </div>
            <div className="row2">
                <div className="tvColumn1">
                  <div style={{
                    width: '100%', 
                    justifyContent:'center', alignItems: 'center'}}>
                    <center>
                      <div className="videoContainer"> 
                        <ReactPlayer 
                          url={this.state.currentVideo.url}
                          controls={true}
                          width={'100%'}
                          height={600}
                          volume={.5}
                          muted={false}
                          playsinline={true}
                          onEnded={() => {
                            this.nextVideo(this.state.currentVideo)
                          }}
                          playing={true}>
                        </ReactPlayer>
                      </div>
                    </center>
                    {this.state.boatScores.length > 0 ? 
                    <div className="headerBoxFull">
                      <div style={{flex: 2}}>
                        <SpeciesScoresColTv speciesId='-LX4iau5LlrGzTyiczlU' speciesName='Dorado' logs={this.state.currentLogs} boatClass={''} />
                      </div>
                      <div style={{flex: 2}}>
                        <SpeciesScoresColTv speciesId='-LX4j879bTHwdelz0Uk6' speciesName='Tuna' logs={this.state.currentLogs} boatClass={''}/>
                      </div>
                    </div> : null}
                  </div>
              </div>
              {this.state.logs.length > 0 ? <div className="logBox" style={{width: '45%'}}>
                <div className="logColumn">
                  <div className='scoreRowTv'>
                    <ScrollerTv boatScores={this.state.boatScores} boatClass={'General'}/>
                  </div>
                  {this.state.boatScores.length > 0 ? <div style={{height: '150px'}}>
                    <SponsorsScrollerTv sponsors={ sponsorLogos } slides={4}/>
                  </div> : null }
                </div>
              </div> : 
              <div style={{width: '45%'}}>
              <TournamentDetailsTv tournament={this.state.tournament} />
              <div className='registerBoxTv'>REGISTER NOW</div>
              <div className='registerBoxTv-sub'><a href='https://thepescadora.com'>WWW.THEPESCADORA.COM</a></div>
              </div> 
              }
            </div>
            {this.state.boatScores.length === 0 ? <div style={{height: '150px'}}>
              <SponsorsScrollerTv sponsors={ sponsorLogos } slides={8}/>
            </div> : null }
            </div>
            <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
              <div className="rowLoading">
                <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                </div>
            </div>
          </TelevisionBreakpoint>
          <DesktopBreakpoint>
          <div className="center_box">
            <div className='registerBoxTv-sub'><a href='https://thepescadora.com/2020-leaderboards/'>Click Here for Pescadora Live Leaderboards</a></div>
          </div>
          </DesktopBreakpoint>
          <TabletBreakpoint>
          <div className="center_box">
            <div className='registerBoxTv-sub'><a href='https://thepescadora.com/2020-leaderboards/'>Click Here for Pescadora Live Leaderboards</a></div>
          </div>
          </TabletBreakpoint>
          <PhoneBreakpoint>
          <div className="center_box">
            <div className='registerBoxTv-sub'><a href='https://thepescadora.com/2020-leaderboards/'>Click Here for Pescadora Live Leaderboards</a></div>
          </div>
          </PhoneBreakpoint>
      </div> 
    );
  }
}

export default Pescadora;


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/Pescadora.js